export default __webpack_public_path__ + "static/media/mac.6b4e1f55.png";